module.exports = __webpack_public_path__ + "img/101.e7ec9747.svg";